<hook ref:topHook class='top-hook'/>

<div class='gia-reconstruction {{isMobile ? "mobile": "desktop"}} {{mode}} {{fix}} {{inIosApp ? "ios-app" : "web"}}'>
	{{#if !inIosApp}}
	<Background scenes='{{scenes}}' sceneIndex='{{sceneIndex}}' position='{{position}}' mode='{{mode}}' fix='{{fix}}' ref:backgroundRef />
	{{/if}}



	<Foreground references='{{references}}' scenes='{{scenes}}' sceneIndex='{{sceneIndex}}' position='{{position}}' mode='{{mode}}' fix='{{fix}}' bind:sceneIndex/>
</div>

<hook ref:bottomHook class='bottom-hook'/>

<style>

hook {
	position: relative;
	height: 0;
}

.gia-reconstruction {
	position: relative;
	overflow-x: hidden;
	overflow-y: hidden;
	width: 100%;
}

.gia-reconstruction.ios-app {
	padding-bottom: 1em;
}

.portrait .gia-reconstruction.bottom {
	background-color: transparent;
}

.gia-source {
	font-family: 'Guardian Text Sans Web';
	font-size: 12px;
	padding: 5px 0;
	border-top: 1px solid #bdbdbd;
	color: #767676;
}

.web.gia-source {
	margin: 0 0.625rem 2em 0.625rem;
}

.gia-scroller-title {
	width: 100%;
}


</style>

<script>
import Background from './Background.html';
import Foreground from './Foreground.html';
import scenes from '../scenes.js';

const inIosApp = typeof navigator === 'undefined' ? true : ( /(iPhone|iPod|iPad).*AppleWebKit(?!.*Version)/i.test( navigator.userAgent ) && /ios/.test( document.body.getAttribute( 'class' ) ) ) ||
/app-preview=true/.test( window.location.search );

const isMobile = typeof navigator === 'undefined' ? true : /mobile/i.test( navigator.userAgent );

export default {
	data () {
		return {
			isMobile,
			inIosApp,
			sceneIndex: 0,
			scenes,
			references: null
		};
	},

	onrender () {
		if ( inIosApp ) {
			const handleResize = () => {
				const mode = ( window.innerWidth > 780 && window.innerWidth > 600 ) ?
				'landscape' :
				'portrait';

				this.set({mode});
			};

			window.addEventListener( 'resize', handleResize, false );
			handleResize();

			return;
		}

		this.topHook = this.refs.topHook;
		this.bottomHook = this.refs.bottomHook;

		this.fixTarget = this.refs.backgroundRef.refs.fixTarget;
		this.set({ references:this.refs });

		const handleScroll = () => {
			const topHook = this.topHook.getBoundingClientRect().top;
			const bottomHook = this.bottomHook.getBoundingClientRect().bottom;

			const fixTargetBcr = this.fixTarget.getBoundingClientRect();
			const fixTargetHeight = fixTargetBcr.bottom - fixTargetBcr.top;

			const top = ( window.innerHeight - fixTargetHeight ) / 2;
			const bottom = ( window.innerHeight + fixTargetHeight ) / 2;
			const fix = topHook < top ? ( bottomHook > bottom ? 'fixed' : 'bottom' ) : 'top';
			this.set({fix});
		};

		const handleResize = () => {
			const mode = ( window.innerWidth > 780 && window.innerWidth > window.innerHeight /*this.fixTarget.offsetHeight*/ ) ?
			'landscape' :
			'portrait';

			this.set({mode});
			handleScroll();
		};

		window.addEventListener( 'scroll', handleScroll, false );

		window.addEventListener( 'resize', handleResize, false );
		handleResize();
	},

	components: {
		Background,
		Foreground
	}

};
</script>
